import { render, staticRenderFns } from "./ListItems.vue?vue&type=template&id=70a2e512&scoped=true&"
import script from "./ListItems.vue?vue&type=script&lang=js&"
export * from "./ListItems.vue?vue&type=script&lang=js&"
import style0 from "./ListItems.vue?vue&type=style&index=0&id=70a2e512&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a2e512",
  null
  
)

export default component.exports